var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    cell: {
        position: 'relative',
        minHeight: '80px',
        minWidth: '100px',
        padding: '4px',
        verticalAlign: 'top',
        border: '1px solid #edebe9',
        backgroundColor: '#ffffff',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
    },
    cellHover: {
        backgroundColor: '#f3f2f1',
    },
    cellCompact: {
        minHeight: '28px',
        minWidth: 0,
        padding: '1px',
    },
    cellToday: {
        backgroundColor: '#f0f6ff',
    },
    cellSelected: {
        backgroundColor: '#e6f2ff',
        outline: '2px solid #0078d4',
        outlineOffset: '-2px',
    },
    cellDisabled: {
        backgroundColor: '#faf9f8',
        cursor: 'not-allowed',
        opacity: 0.5,
    },
    cellSecondary: {
        backgroundColor: '#faf9f8',
    },
    cellFocused: {
        outline: '2px solid #0078d4',
        outlineOffset: '-2px',
    },
    dayHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '4px',
    },
    dayHeaderCompact: {
        justifyContent: 'center',
        marginBottom: '1px',
    },
    dayNumber: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '24px',
        height: '24px',
        fontSize: '13px',
        fontWeight: 400,
        color: '#323130',
        borderRadius: '50%',
    },
    dayNumberCompact: {
        minWidth: '18px',
        height: '18px',
        fontSize: '11px',
    },
    dayNumberToday: {
        backgroundColor: '#0078d4',
        color: '#ffffff',
        fontWeight: 600,
    },
    dayNumberSelected: {
        backgroundColor: '#0078d4',
        color: '#ffffff',
    },
    dayNumberSecondary: {
        color: '#a19f9d',
    },
    customIcon: {
        marginLeft: '4px',
        fontSize: '12px',
    },
    addEventButton: {
        display: 'none',
        alignItems: 'center',
        justifyContent: 'center',
        width: '20px',
        height: '20px',
        padding: 0,
        border: 'none',
        borderRadius: '50%',
        backgroundColor: '#0078d4',
        color: '#ffffff',
        fontSize: '14px',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'opacity 0.15s ease',
    },
    eventsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        overflow: 'hidden',
    },
    eventIndicator: {
        height: '4px',
        borderRadius: '2px',
        marginBottom: '1px',
    },
    moreIndicator: {
        fontSize: '11px',
        color: '#605e5c',
        cursor: 'pointer',
        marginTop: '2px',
    },
};
/**
 * Generate dynamic styles based on state
 */
export const getCellStyles = (options) => {
    const { isToday, isSelected, isDisabled, isSecondary, isFocused, isHovered } = options;
    let cellStyle = Object.assign({}, styles.cell);
    if (isSecondary)
        cellStyle = Object.assign(Object.assign({}, cellStyle), styles.cellSecondary);
    if (isToday)
        cellStyle = Object.assign(Object.assign({}, cellStyle), styles.cellToday);
    if (isHovered)
        cellStyle = Object.assign(Object.assign({}, cellStyle), styles.cellHover);
    if (isSelected)
        cellStyle = Object.assign(Object.assign({}, cellStyle), styles.cellSelected);
    if (isFocused)
        cellStyle = Object.assign(Object.assign({}, cellStyle), styles.cellFocused);
    if (isDisabled)
        cellStyle = Object.assign(Object.assign({}, cellStyle), styles.cellDisabled);
    return cellStyle;
};
export default styles;
//# sourceMappingURL=CalendarCell.styles.js.map